import {library} from '@fortawesome/fontawesome-svg-core';
import {
    faBellSlash,
    faBuilding,
    faExternalLink,
    faFileLines,
    faFileAudio,
    faFileImage,
    faFileWord,
    faFilePdf,
    faRobot,
    faEdit,
    faTimesCircle,
    faCheckCircle,
    faListOl,
    faCaretDown,
    faCheck,
    faCog,
    faQuestionCircle,
    faCogs,
    faColumns,
    faTimes,
    faEllipsisV,
    faEnvelope,
    faChevronRight,
    faChevronLeft,
    faChevronUp,
    faExclamationCircle,
    faExclamationTriangle,
    faTriangleExclamation,
    faUpRightFromSquare,
    faEye,
    faInbox,
    faLink,
    faPhone,
    faPowerOff,
    faSearch,
    faStroopwafel,
    faSyncAlt,
    faTags,
    faUnlink,
    faUser,
    faHandshake,
    faFileExport,
    faUserEdit,
    faUserPlus,
    faPlus,
    faUsers,
    faQuestion,
    faPencilAlt,
    faCopy,
    faChevronDown, faTrash, faPlusSquare, faMinusSquare, faUniversalAccess, faChartLine,
    faBinoculars,
    faFileExcel,
    // Hero del modal de conectar un Sheet/CSV (`channels/sheet/AddAdAccountForm`). Sin registrar,
    // `FaIcon` no renderiza NADA: warning en consola y un hueco donde va el ícono.
    faFileCsv,
    faStar,
    faArrowLeft, faArrowRight, faEquals, faTable, faBan, faInfoCircle,
    faExpand,
    faUserShield, faExchangeAlt,
    // La tarjeta del límite de usuarios cliente (`ClientUsersLimitNotice`) y la de tipo Cliente al invitar.
    faUserTag,
    faWandMagicSparkles,
    faListCheck, faCircleQuestion,
    faBook,
    faCirclePlus,
    faChartBar,
    faMicrochip,
    faComments,
    faPlug,
    faCode,
    faTerminal,
    faShuffle,
    faGear,
    faHandPointer,
    faGift,
    faGaugeHigh,
    faBullseye,
    faTableCellsLarge,
    faBell,
    faChartPie,
    faMagnifyingGlassChart,
    faXmark,
    faBolt,
    faLayerGroup,
    // Media Plan — empty state por motivo: no hay solapa del mes / la solapa mezcla monedas.
    faCalendarXmark,
    faCoins,
    faLock,
    faCrown,
    faBookmark,
    faGripVertical,
    faFloppyDisk,
    faFolderOpen,
    faShoppingBag,
    faCalculator,
    faCircleCheck,
    faClock,
    faShareNodes,
    faVideo,
    faThumbsUp,
    faThumbsDown,
    faBrain,
    faCloudArrowUp,
    faCircleXmark,
    faRotate,
    faWeightHanging,
    faCircle,
    faCircleHalfStroke
} from '@fortawesome/free-solid-svg-icons';

// `faFacebook` (badge redondeado, iconName `facebook`) y `faFacebookF` (la "f" sola, iconName
// `facebook-f`) son DOS íconos distintos. El botón de login de Meta pide `['fab','facebook-f']`
// —la letra es la marca que Meta usa en los botones "Continuar con Facebook", no el badge de
// perfil— y sin registrarlo no renderizaba nada: hueco vacío + "Could not find icon" en consola,
// con el `margin-right: 8px` de `.btn.facebook .fa` guardando el lugar.
import {faGoogle, faGoogleDrive, faFacebook, faFacebookF, faTiktok, faMeta, faLinkedin} from '@fortawesome/free-brands-svg-icons';
import {faDownload} from '@fortawesome/free-solid-svg-icons';
// El selector de idioma del portal del cliente (`portal/PortalLanguageMenu`).
import {faGlobe} from '@fortawesome/free-solid-svg-icons';

export function initIconsLibrary() {
    library.add(
        faStroopwafel,
        faUserPlus,
        faPlus,
        faHandshake,
        faUserEdit,
        faFileExport,
        faCheck,
        faCaretDown,
        faColumns,
        faEllipsisV,
        faUnlink,
        faLink,
        faTags,
        faSyncAlt,
        faBellSlash,
        faChevronRight,
        faChevronLeft,
        faChevronUp,
        faExclamationTriangle,
        faTriangleExclamation,
        faUpRightFromSquare,
        faBuilding,
        faRobot,
        faEdit,
        faCheckCircle,
        faTimesCircle,
        faListOl,
        faUsers,
        faUser,
        faTimes,
        faCogs,
        faQuestionCircle,
        faCog,
        faSearch,
        faExclamationCircle,
        faPowerOff,
        faEnvelope,
        faEye,
        faInbox,
        faPhone,
        faFacebook,
        faFacebookF,
        faGoogle,
        faGoogleDrive,
        faTiktok,
        faMeta,
        faLinkedin,
        faDownload,
        faQuestion,
        faPencilAlt,
        faCopy,
        faChevronDown,
        faTrash,
        faPlusSquare,
        faMinusSquare,
        faUniversalAccess,
        faChartLine,
        faBinoculars,
        faFileExcel,
        faFileCsv,
        faStar,
        faArrowLeft,
        faArrowRight,
        faEquals,
        faTable,
        faBan,
        faInfoCircle,
        faExpand,
        faUserShield,
        faUserTag,
        faExchangeAlt,
        faFileLines,
        faFileAudio,
        faFileImage,
        faFileWord,
        faFilePdf,
        faExternalLink,
        faWandMagicSparkles,
        faListCheck, faCircleQuestion,
        faBook,
        faCirclePlus,
        faChartBar,
        faMicrochip,
        faComments,
        faPlug,
        faCode,
        faTerminal,
        faShuffle,
        faGear,
        faHandPointer,
        faGift,
        faGaugeHigh,
        faBullseye,
        faTableCellsLarge,
        faBell,
        faChartPie,
        faMagnifyingGlassChart,
        faXmark,
        faBolt,
        faLayerGroup,
        faCalendarXmark,
        faCoins,
        faLock,
        faCrown,
        faBookmark,
        faGripVertical,
        faFloppyDisk,
        faFolderOpen,
        faShoppingBag,
        faCalculator,
        faCircleCheck,
        faClock,
        faShareNodes,
        faVideo,
        faThumbsUp,
        faThumbsDown,
        faBrain,
        faCloudArrowUp,
        faCircleXmark,
        faRotate,
        faWeightHanging,
        faCircle,
        faCircleHalfStroke,
        faGlobe
    );
}
